import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = ["id", "checked"]
const _hoisted_3 = ["for"]


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: {
    id: String,
    label: String,
    modelValue: Boolean,
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const input = (checked: boolean) => {
    emit("update:modelValue", checked);
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps({
      id: __props.id,
      type: "checkbox"
    }, _ctx.$attrs, {
      onInput: _cache[0] || (_cache[0] = ($event: any) => (input($event.target.checked))),
      checked: __props.modelValue
    }), null, 16 /* FULL_PROPS */, _hoisted_2),
    _createElementVNode("label", { for: __props.id }, _toDisplayString(__props.label), 9 /* TEXT, PROPS */, _hoisted_3)
  ]))
}
}

})